module.exports = __webpack_public_path__ + "static/media/Notch_After.29589a78.jpg";